module.exports = __webpack_public_path__ + "media/images/promotions/cards/chance-5-1529a1e510783f32fb7ab66dcac493ca.svg";